export function partnersInfoNavSlider() {
    let sliderNav = $(".partners-info-nav");
    let itemsParent = $(".partners-info-slider");
    $(window).on("load resize", function () {
        sliderNavInit();
    });

    function sliderNavInit() {
        if (window.innerWidth >= 1024 && sliderNav.hasClass("slick-initialized")) {
            sliderNav.slick('unslick');
        }
        if (window.innerWidth >= 1024 && !sliderNav.hasClass("slider-destroyed")) {
            sliderNav.addClass("slider-destroyed").find(".item:first-child button").trigger("click");
        }
        if (window.innerWidth < 1024 && !sliderNav.hasClass("slick-initialized")) {
            sliderNav.removeClass("slider-destroyed").find(".item").removeClass("active");
            setTimeout(function (){
                sliderNavOption();
            },300);
        }
    }

    function sliderNavOption() {
        sliderNav.not('.slick-initialized').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            focusOnSelect: true,
            arrows: false,
            variableWidth: true
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            itemsParent.find(".item").removeClass("active");
            itemsParent.find(".item").eq(nextSlide).addClass("active");
        });
    }

    sliderNav.on("click", "button", function () {
        if (window.innerWidth >= 1024) {
            let $this = $(this);
            let nextSlide = $this.parent().index();
            itemsParent.find(".item").removeClass("active");
            itemsParent.find(".item").eq(nextSlide).addClass("active");
            sliderNav.find(".item").removeClass("active");
            $this.parent().addClass("active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/partnersInfoNavSlider.js